var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "changelog-delta",
      attrs: { "data-testid": "changelog-delta" }
    },
    [
      _vm.changes.length > 0
        ? _c(
            "div",
            { staticClass: "p-l-5 f-s-12" },
            [
              _c("ChangeUpdateChanges", {
                staticClass: "changelog-delta-list",
                attrs: { items: _vm.changes, wide: _vm.wide }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }